import React from 'react';
import { FormError, HelpText } from '@Forms/fields.jsx';

const SelectField = ({
  children,
  error,
  helpText,
  label,
  name,
  placeholder = '',
  register,
  options = {},
  ...props
}) => {
  // resuable text field
  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-select ` +
        (error ? 'sb-form-item-error' : '')
      }
    >
      <label htmlFor={name}>{label}</label>
      <div className="sb-form-item-content">
        <select
          aria-invalid={error ? 'true' : 'false'}
          {...register(name, options)}
          {...props}
        >
          {children}
        </select>
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );
};

export default SelectField;
